import {fromUrlToFilters, objectToArray, TAGS_FILTER_PARAM} from 'shared/lib/filterHelper';
import IOrderBy from 'shared/model/IOrderBy';

import IDomainIncidentFilters from 'features/domain/model/DomainIncident/IDomainIncidentFilters';
import IDomainMonitorsFilters from 'features/domain/model/DomainMonitor/IDomainMonitorsFilters';

export const DOMAIN_MONITORS_DEFAULT_SORT: IOrderBy = {field: 'id', direction: 'desc'};

export const DOMAIN_MONITORS_ORDER_FIELDS: readonly string[] = [
    'id',
    'domain',
    'active',
    'ssl_active_to',
    'domain_active_to',
    'ssl_redirect',
    'rkn_block',
];

export const DOMAIN_INCIDENTS_ORDER_FIELDS: readonly string[] = [
    'id',
    'resolved',
    'domain',
    'type',
    'created_at',
    'expire_at',
    'resolved_at',
];

export function getDomainIncidentFilters(params: URLSearchParams): IDomainIncidentFilters {
    const filters: IDomainIncidentFilters = {};
    fromUrlToFilters(params, filters, 'domain');
    fromUrlToFilters(params, filters, 'domain_monitor.uuid');
    fromUrlToFilters(params, filters, 'created_at[after]');
    fromUrlToFilters(params, filters, 'created_at[before]');
    fromUrlToFilters(params, filters, 'expire_at[after]');
    fromUrlToFilters(params, filters, 'expire_at[before]');
    fromUrlToFilters(params, filters, 'resolved_at[after]');
    fromUrlToFilters(params, filters, 'resolved_at[before]');
    const typeValues = params.getAll('type[]');
    if (typeValues.length > 0) {
        (filters as any).type = typeValues;
    }

    return filters;
}

export function getDomainMonitorsFilters(params: URLSearchParams): IDomainMonitorsFilters {
    const filters: IDomainMonitorsFilters = {};
    fromUrlToFilters(params, filters, 'domain');
    fromUrlToFilters(params, filters, 'active');
    fromUrlToFilters(params, filters, 'ssl_redirect');
    fromUrlToFilters(params, filters, 'rkn_block');
    fromUrlToFilters(params, filters, 'ssl_active_to[after]');
    fromUrlToFilters(params, filters, 'ssl_active_to[before]');
    fromUrlToFilters(params, filters, 'domain_active_to[after]');
    fromUrlToFilters(params, filters, 'domain_active_to[before]');
    const tags = params.getAll(TAGS_FILTER_PARAM);
    if (tags.length > 0) {
        filters.tags = tags;
    }

    return filters;
}

export function getDomainIncidentFilterArray(params: URLSearchParams): string[] {
    return objectToArray(getDomainIncidentFilters(params));
}

export function getDomainMonitorsFilterArray(params: URLSearchParams): string[] {
    return objectToArray(getDomainMonitorsFilters(params));
}
